import type { FormResponseDraft as IFormResponseDraft } from 'api/models';
import type { FormResponse } from 'components/organisms/forms/form-types';

export class FormResponseDraft implements IFormResponseDraft {
  response: FormResponse;

  timestamp: number;

  formInstance: number;

  constructor(resp: IFormResponseDraft) {
    this.response = resp.response;
    this.timestamp = resp.timestamp;
    this.formInstance = resp.formInstance;
  }
}
